<template>
	<div class="channel">
		<el-radio-group
			v-model="pageRadio"
			size="small"
			@change="handleRadioChange"
		>
			<el-radio-button label="add">添加渠道</el-radio-button>
			<el-radio-button label="revise">报错修改</el-radio-button>
			<el-radio-button label="recordSKU">备案SKU</el-radio-button>
			<el-radio-button label="updateChannel">更新渠道</el-radio-button>
			<el-radio-button label="channelConfigure">渠道配置</el-radio-button>
		</el-radio-group>
		<el-form
			class="custom-formScreen"
			:model="formScreen"
			ref="formScreen"
			label-width="5vw"
			inline
		>
			<el-collapse-transition>
				<div v-show="showFilter">
					<el-form-item label="分公司" prop="branchCompanyId">
						<el-select
							v-model="formScreen.branchCompanyId"
							filterable
							clearable
							placeholder="请选择"
							@change="selectChange"
						>
							<el-option
								v-for="item in listBranch"
								:key="item.id"
								:label="item.companyFullName"
								:value="item.id"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="子公司" prop="companyId">
						<el-select
							v-model="formScreen.companyId"
							filterable
							clearable
							placeholder="请选择"
						>
							<el-option
								v-for="item in listSon"
								:key="item.id"
								:label="item.companyFullName"
								:value="item.id"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="开始日期" prop="startTimeString">
						<el-date-picker
							v-model="formScreen.startTimeString"
							align="right"
							type="date"
							placeholder="选择开始日期"
							format="yyyy-MM-dd HH:mm:ss"
							value-format="yyyy-MM-dd HH:mm:ss"
						></el-date-picker>
					</el-form-item>
					<el-form-item label="结束日期" prop="endTimeString">
						<el-date-picker
							v-model="formScreen.endTimeString"
							align="right"
							type="date"
							placeholder="选择结束日期"
							format="yyyy-MM-dd HH:mm:ss"
							value-format="yyyy-MM-dd HH:mm:ss"
						></el-date-picker>
					</el-form-item>
					<el-form-item
						label="渠道状态"
						prop="isHasChannel"
						v-show="pageRadio === 'add'"
					>
						<el-select
							v-model="formScreen.isHasChannel"
							clearable
							filterable
							placeholder="请选择"
						>
							<el-option
								v-for="item in checkList"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="选择平台">
						<el-select
							v-model="formScreen.source"
							clearable
							filterable
							placeholder="请选择"
						>
							<el-option
								v-for="item in platforms"
								:key="item.itemTypeId"
								:label="item.itemTypeName"
								:value="item.itemTypeId"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="国际运单状态" style="width: 60%">
						<el-radio-group
							v-model="formScreen.resource3"
							@change="radiochange3"
						>
							<el-radio
								v-for="item in listWaybillStatus"
								:key="item.id"
								:label="item.itemTypeId" @click.native.prevent="cancelSelect(item.itemTypeId, 'resource3')">{{ item.itemTypeName }}
							</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="订单标记" style="width: 90%">
						<el-radio-group
							v-model="formScreen.orderMark"
							@change="radiochange4"
						>
							<el-radio
								v-for="item in colorlist"
								:key="item.itemTypeId"
								:label="item.itemTypeId" @click.native.prevent="cancelSelect(item.itemTypeId, 'orderMark')">{{ item.itemTypeName }}
							</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="订单类型" style="width:60%;">
						<el-radio-group
							v-model="formScreen.orderType"
							@change="radiochange5"
						>
								<el-radio v-for="item in this.colorList4" :key="item.id" :label="item.itemTypeId" @click.native.prevent="cancelSelect(item.itemTypeId, 'orderType')">{{
									item.itemTypeName
								}}</el-radio>
						</el-radio-group>
					</el-form-item>
					<br />
					<el-form-item
						label="亚马逊状态"
						prop="orderStatus"
						v-show="pageRadio === 'add'"
					>
						<el-select
							v-model="formScreen.orderStatus"
							clearable
							filterable
							placeholder="请选择"
						>
							<el-option
								v-for="item in Ymxpurchase" 
								:key="item.value"
								:label="item.label"
								:value="item.label"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item
						prop="countryName"
						label="国家"
						v-show="pageRadio === 'add'"
					>
						<el-select v-model="formScreen.countryName" clearable filterable>
							<el-option
								v-for="item in this.listCountry"
								:key="item.id"
								:label="item.countryName"
								:value="item.countryName"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item
						prop="conveyNumber"
						label="国际单号"
						v-show="pageRadio === 'add'"
					>
						<el-input v-model.trim="formScreen.conveyNumber"></el-input>
					</el-form-item>
					<el-form-item prop="batchNo" label="批次号">
						<el-input v-model.trim="formScreen.batchNo"></el-input>
					</el-form-item>
				</div>
			</el-collapse-transition>
			<el-form-item prop="searchString" label=" " style="width: 30%">
				<el-input
					v-model.trim="formScreen.searchString"
					placeholder="订单号、订单ID、系统SKU"
				></el-input>
			</el-form-item>
			<el-form-item prop="searchString" label=" " style="width: 20%">
				<el-select v-model="formScreen.addressStatus" placeholder="地址状态" clearable>
					<el-option label="有地址" value="1"></el-option>
					<el-option label="无地址" value="2"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item prop="searchStrings" label=" " style="width: 50%">
				<el-input
					v-model.trim="formScreen.searchStrings"
					placeholder="多个订单号，以空格分开"
					style="width: calc(100% - 300px);"
				></el-input>
				<el-button
					type="primary"
					style="margin-left: 10px;"
					@click="searchFrom"
					>搜索</el-button
				>
				<el-button type="primary" @click="resetFprm('formScreen')"
					>重置</el-button
				>
				<el-button type="warning" @click="showFilter=!showFilter">{{ showFilter?'隐藏筛选条件':'显示筛选条件' }}</el-button>
			</el-form-item>
		</el-form>

		<el-button
			type="primary"
			style="margin-bottom: 20px;"
			@click="batchCreateWaybill"
			v-if="pageRadio === 'add'"
			>批量生成运单</el-button
		>
		<template v-if="pageRadio === 'add'">
			<el-button @click="clearFilter">清除所有过滤器</el-button>
			<el-button type="primary" style="margin-left: 900px"  @click="importDetail = true">
							导入第三方物流
			</el-button>
			<el-button type="primary" style="margin-left: 10px"  @click="exportDetail = true">
							导出地址信息
			</el-button>
			<el-button type="primary" style="margin-left: 10px" @click="dialogVisible = true">
							导入地址信息
						</el-button>
			<el-button type="primary" style="margin-left: 10px" @click="exportWaybilldialog = true">导出面单</el-button>
			<el-dialog title="导出地址信息" :visible.sync="exportDetail" width="28%">
					<textarea 
						v-model="textareaContent" 
						@input="updateContentArray"
						autocomplete="off" 
						placeholder="每行输入一个单号，多个单号信息以回车键换行" class="el-textarea__inner" 
						style="min-height: 306px; height: 306px;">
					</textarea>
					<div slot="footer" class="dialog-footer">
						<el-button @click="closeRemark">取 消</el-button>
						<el-button type="primary" @click="submitRemark">提 交</el-button>
					</div>
			</el-dialog>
			<el-dialog title="导出面单" :visible.sync="exportWaybilldialog" width="28%">
					<textarea 
						v-model="exportWaybillContent" 
						autocomplete="off" 
						placeholder="每行输入一个单号，多个单号信息以回车键换行" class="el-textarea__inner" 
						style="min-height: 306px; height: 306px;">
					</textarea>
					<div slot="footer" class="dialog-footer">
						<el-button @click="exportWaybilldialog = false">取 消</el-button>
						<el-button type="primary" @click="exportWaybill">提 交</el-button>
					</div>
			</el-dialog>
			<el-dialog
					title="导入第三方物流"
					:visible.sync="importDetail"
					width="30%"
					@close="handleUploadExcelDialogClose"
					:close-on-click-modal="false"
					:close-on-press-escape="false"
					destroy-on-close
				>
					<el-row type="flex" align="middle">
						<upload-excel-component :on-success="handleUploadExcelSuccess2"/>
						<el-button style="margin-left: 10px;" @click="downloadTemplate2">下载模板</el-button>
					</el-row>
					<div class="file-box">
						<div v-for="(item, index) in listFile2" :key="index">{{ `${index + 1}. ${item.fileName}` }}</div>
					</div>
					<div slot="footer">
						<el-button
							size="small"
							@click="handleUploadExcelSubmit2"
							:loading="btnLoading"
						>确定导入
						</el-button>
					</div>
			</el-dialog>	
			<el-dialog
					title="导入地址信息"
					:visible.sync="dialogVisible"
					width="30%"
					@close="handleUploadExcelDialogClose"
					:close-on-click-modal="false"
					:close-on-press-escape="false"
					destroy-on-close
				>
					<el-row type="flex" align="middle">
						<upload-excel-component :on-success="handleUploadExcelSuccess"/>
						<el-button style="margin-left: 10px;" @click="downloadTemplate">下载模板</el-button>
					</el-row>
					<div class="file-box">
						<div v-for="(item, index) in listFile" :key="index">{{ `${index + 1}. ${item.fileName}` }}</div>
					</div>
					<div slot="footer">
						<el-button
							size="small"
							@click="handleUploadExcelSubmit"
							:loading="btnLoading"
						>确定导入
						</el-button>
					</div>
			</el-dialog>			
			<el-table
				key="add"
				ref="filterTable"
				:data="listTable"
				:header-cell-style="headClass"
				border
				v-loading="loadingTable"
				@selection-change="handleSelectionChange"
			>
				<el-table-column
					type="selection"
					width="50"
					align="center"
				></el-table-column>
				<el-table-column
					prop="orderId"
					label="订单号"
					align="left"
					width="270"
				>
					<template slot-scope="scope">
						<div>订单号：{{ scope.row.amazonOrderId }}</div>
						<div>
							订单ID：
							<span>{{ scope.row.id }}</span>
						</div>
            <p v-if="scope.row.shipmentBoxId !== null && scope.row.shipmentBoxId !== ''">运输编号：{{ scope.row.shipmentBoxId }}</p>
						<div :style="{background:scope.row.sellercolor,'padding':'0 5px','color':'white','display':'inline-block','border-radius':'5px','font-size':'10px'}">{{scope.row.itemTypeName}}</div>
						<el-row type="flex" align="middle">
							<el-tag
								style="margin-right:5px;"
								v-for="tag in scope.row.channelMarkItems"
								:color="tag.itemName"
								:key="tag.id"
								effect="dark"
								size="mini"
								:type="tag.type"
								>{{ tag.itemTypeName }}
							</el-tag>
							<el-tag
								v-if="scope.row.outInterceptStatus === 1"
								type="danger"
								effect="dark"
								size="mini"
								>拦截</el-tag
							>
							<el-tag
								style="margin-right:5px;"
								:color="scope.row.orderType?colorList4[scope.row.orderType].itemName:'#fff'"
								effect="dark"
								size="mini"
								v-if="scope.row.orderType"
							>
								{{scope.row.orderType?colorList4[scope.row.orderType].itemTypeName:''}}
							</el-tag>
							<el-popover
								v-if="scope.row.orderRemarks.length != 0"
								style="display:flex;"
								placement="top-start"
								trigger="hover"
							>
								<h3>渠道备忘录</h3>
								<div
									v-for="(item, index) in scope.row
										.orderRemarks"
									:key="index"
								>
									<span>{{ item.roleName }}</span>
									<span v-if="item.userName !== null">-</span>
									<span>{{ item.userName }}</span
									>: <span>{{ item.remarkContent }}</span
									>--
									<span>{{ item.createTime }}</span>
								</div>
								<img
									class="Memo"
									slot="reference"
									src="../../assets/imags/备忘录.png"
									alt
								/>
							</el-popover>
							<el-popover
								placement="top-start"
								title="物流内部备注"
								width="650"
								trigger="hover"
							>
								<el-table
									:data="RemarkList"
									style="width: 100%"
								>
									<el-table-column
										prop="roleName"
										label="添加人"
										width="120"
										align="center"
									></el-table-column>
									<el-table-column
										prop="remarkContent"
										label="内容"
										width="330"
										align="center"
									></el-table-column>
									<el-table-column
										prop="createTime"
										label="时间"
										width="200"
										align="center"
									></el-table-column>
								</el-table>
								<i
									class="el-icon-s-order"
									style="font-size:18px;"
									slot="reference"
									@mouseover="orderIdchange(scope.row)"
								></i>
							</el-popover>
							<el-tooltip
								class="item"
								effect="dark"
								content="订单冻结"
								placement="bottom"
								v-if="scope.row.isFreeze === 1"
							>
								<i
									class="element-icons hx-snow"
									style="font-size: 40px;color: #1296db;line-height: 40px;"
								></i>
							</el-tooltip>
						</el-row>
					</template>
				</el-table-column>
				<el-table-column
					prop="addressCountryCode"
					label="国家"
					align="center"
					width="80"
				></el-table-column>
				<el-table-column
					label="批量生成状态"
					align="center"
					width="120"
					:filters="[{ text: '生成中', value: 0 }, { text: '成功', value: 1 }, { text: '失败', value: 2 }, { text: '待返回', value: 3 }, { text: '--', value: '--' }]"
					:filter-method="filterTag"
				>
					<template slot-scope="scope">
						<template
							v-if="
								scope.row.channelTask &&
									Object.keys(scope.row.channelTask).length
							"
						>
							<div v-if="scope.row.channelTask.status === 0">
								生成中
							</div>
							<div
								v-else-if="scope.row.channelTask.status === 1"
								style="color: green;"
							>
								成功
							</div>
							<el-tooltip
								effect="dark"
								:content="scope.row.channelTask.failReason"
								placement="top"
								v-else-if="scope.row.channelTask.status === 2"
							>
								<div style="color: red;">失败</div>
							</el-tooltip>
							<div
								v-else-if="scope.row.channelTask.status === 3"
								style="color: #2775b6;"
							>
								待返回
							</div>
						</template>
						<template v-else>
							<div>--</div>
						</template>
					</template>
				</el-table-column>
				<el-table-column label="产品信息" align="left" min-width="300">
					<template slot-scope="scope">
						<template
							v-if="
								scope.row.orderItems &&
									scope.row.orderItems.length
							"
						>
							<el-row
								type="flex"
								align="middle"
								v-for="item in scope.row.orderItems"
								:key="item.id"
							>
								<el-popover
									trigger="hover"
									placement="right"
									v-if="item.imageUrl"
								>
									<img
										:src="item.imageUrl"
										class="prduct_img"
										alt
									/>
									<div class="scope_img" slot="reference">
										<img :src="item.imageUrl" alt />
									</div>
								</el-popover>
								<el-button
									type="text"
									size="mini"
									v-else
									@click="getOriginalImg(item)"
									style="padding: 0;"
									>查看原图
								</el-button>
								<span>
									<div>
										price:
										{{
											item.itemAmount +
												item.itemCurrencyCode
										}}
									</div>
									<div>SKU1: {{ item.sellerSKU }}</div>
									<div style="width: 100;" v-show="item.channel">
										<strong style="color:black">订单渠道:</strong> {{ item.channel }}
									</div>
									<div style="width: 100;" v-show="item.logisticsType">
										<strong style="color:black">客户物流方式:</strong> {{ item.logisticsType }}
									</div>
									<div style="width: 100;" v-show="item.logisticsServiceName">
										<strong style="color:black">物流服务名称:</strong> {{ item.logisticsServiceName }}
									</div>
								</span>
							</el-row>
						</template>
					</template>
				</el-table-column>
				<el-table-column
					label="亚马逊订单状态"
					prop="orderStatus"
					align="center"
					width="100"
				>
					<template slot-scope="scope">
						<div v-if="scope.row.orderStatus === '未发货'">
							<span style="color:red">{{
								scope.row.orderStatus
							}}</span>
						</div>
						<div v-else-if="scope.row.orderStatus != '未发货'">
							<span>{{ scope.row.orderStatus }}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column
					label="平台"
					align="center"
					width="110"
					prop="sourceclass"
				>
				</el-table-column>
				<el-table-column
					prop="waybillInternationalNumber"
					label="国际运单"
					align="center"
					width="400"
				>
					<template slot-scope="scope">
						<div
							v-for="(item, index) in scope.row.orderChannels"
							:key="index"
						>
							{{ item.conveyNumber }}:
							<!--              <span style="color:blue;" v-if="item.status === 0">未发货</span>-->
							<!--              <span style="color:red;" v-else-if="item.status === 1">作废</span>-->
							<!--              <span style="color:blue;" v-else-if="item.status === 2">未发货</span>-->
							<!--              <span style="color:blue;" v-else-if="item.status === 3">未发货</span>-->
							<!--              <span style="color:green;" v-else-if="item.status === 4">已发货</span>-->
							<span
								:style="{
									color:
										internationalOrderStatus[item.status]
											.color,
								}"
							>
								{{
									internationalOrderStatus[item.status].title
								}}
							</span>
							<span>
								{{ `/${item.applyTotal}` }}
							</span>
							<p>{{ item.batchNo }} &nbsp;&nbsp;&nbsp; 渠道: {{ item.channelName }}</p>
							<p>路线: {{ item.channelWay }}</p>
							<el-divider v-if="index != (scope.row.orderChannels.length-1)" />
						</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="quantityOfOrdered"
					label="数量"
					align="center"
					width="80"
				></el-table-column>
				<el-table-column
					prop="purchaseDate"
					label="下单时间"
					align="center"
					width="200"
				></el-table-column>
				<el-table-column
					width="200"
					prop="ziName"
					label="所属公司"
					align="center"
				>
					<template slot-scope="scope">
						<div>
							<span>{{ scope.row.branchCompanyName }}</span>
							<span
								v-if="
									scope.row.branchCompanyName &&
										scope.row.subCompanyName
								"
								>&nbsp;-&nbsp;</span
							>
							<span>{{ scope.row.subCompanyName }}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column
					label="操作"
					fixed="right"
					width="80"
					align="center"
				>
					<template slot-scope="scope">
						<i
							class="el-icon-edit-outline fontSize-30"
							@click="edit(scope.row)"
						></i>
					</template>
				</el-table-column>
			</el-table>
			<el-row
				class="pagination-box"
				type="flex"
				justify="center"
				align="middle"
			>
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="page"
					:page-sizes="[20, 50, 100, 200]"
					:page-size="size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</el-row>
		</template>

		<template v-else-if="pageRadio === 'revise'">
			<el-table
				key="revise"
				:data="listTable1"
				:header-cell-style="headClass"
				border
				v-loading="loadingTable1"
				@selection-change="handleSelectionChange"
			>
				<el-table-column
					type="selection"
					width="50"
					align="center"
				></el-table-column>
				<el-table-column
					prop="orderId"
					label="订单号"
					align="left"
					width="240"
				>
					<template slot-scope="scope">
						<div>订单号：{{ scope.row.amazonOrderId }}</div>
						<div>
							订单ID：
							<span>{{ scope.row.orderId }}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="产品信息" align="left" min-width="260">
					<template slot-scope="scope">
						<template
							v-if="
								scope.row.orderItems &&
									scope.row.orderItems.length
							"
						>
							<el-row
								type="flex"
								align="middle"
								v-for="item in scope.row.orderItems"
								:key="item.id"
							>
								<el-popover
									trigger="hover"
									placement="right"
									v-if="item.imageUrl"
								>
									<img
										:src="item.imageUrl"
										class="prduct_img"
										alt
									/>
									<div class="scope_img" slot="reference">
										<img :src="item.imageUrl" alt />
									</div>
								</el-popover>
								<el-button
									type="text"
									size="mini"
									v-else
									@click="getOriginalImg(item)"
									style="padding: 0;"
									>查看原图
								</el-button>
								<span>
									<div>
										price:
										{{
											item.itemAmount +
												item.itemCurrencyCode
										}}
									</div>
									<div>SKU: {{ item.sellerSKU }}</div>
								</span>
							</el-row>
						</template>
					</template>
				</el-table-column>
				<el-table-column
					prop="waybillInternationalNumber"
					label="国际运单"
					align="center"
					width="260"
				>
					<template slot-scope="scope">
						<div
							v-for="(item, index) in scope.row.orderChannels"
							:key="index"
						>
							{{ item.conveyNumber }}:
							<!--              <span style="color:blue;" v-if="item.status === 0">未发货</span>-->
							<!--              <span style="color:red;" v-else-if="item.status === 1">作废</span>-->
							<!--              <span style="color:blue;" v-else-if="item.status === 2">未发货</span>-->
							<!--              <span style="color:blue;" v-else-if="item.status === 3">未发货</span>-->
							<!--              <span style="color:green;" v-else-if="item.status === 4">已发货</span>-->
							<span
								:style="{
									color:
										internationalOrderStatus[item.status]
											.color,
								}"
							>
								{{
									internationalOrderStatus[item.status].title
								}}
							</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="quantityOfOrdered"
					label="数量"
					align="center"
					width="80"
				></el-table-column>
				<el-table-column
					prop="purchaseDate"
					label="下单时间"
					align="center"
					width="200"
				></el-table-column>
				<el-table-column
					width="200"
					prop="ziName"
					label="所属公司"
					align="center"
				>
					<template slot-scope="scope">
						<div>
							<span>{{ scope.row.branchCompanyName }}</span>
							<span
								v-if="
									scope.row.branchCompanyName &&
										scope.row.subCompanyName
								"
								>&nbsp;-&nbsp;</span
							>
							<span>{{ scope.row.subCompanyName }}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column
					label="操作"
					fixed="right"
					width="80"
					align="center"
				>
					<template slot-scope="scope">
						<i
							class="el-icon-edit-outline fontSize-30"
							@click="edit(scope.row)"
						></i>
					</template>
				</el-table-column>
			</el-table>
			<el-row
				class="pagination-box"
				type="flex"
				justify="center"
				align="middle"
			>
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="page"
					:page-sizes="[20, 50, 100, 200]"
					:page-size="size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total1"
				></el-pagination>
			</el-row>
		</template>

		<channelDepartment
			ref="channelDepartment"
			:page-radio="pageRadio"
			:user-info="UserInfo"
			@channelChangeConfirm="channelChangeConfirm"
			@close="handleClose"
		/>
		<!-- @confirm="channelDepartmentConfirm" -->

		<el-dialog
			width="30%"
			title="更新渠道"
			:visible.sync="dialogUpdateChannel"
		>
			<el-form label-width="100" inline>
				<el-form-item label="选择渠道：">
					<el-select
						v-model="channelVal"
						filterable
						value-key="itemTypeId"
					>
						<el-option
							v-for="item in listChannel"
							:key="item.itemTypeId"
							:label="item.itemTypeName"
							:value="item.itemTypeId"
						></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogUpdateChannel = false"
					>取 消</el-button
				>
				<el-button
					type="primary"
					@click="submitUpdateChannel"
					:loading="loadingStatus"
					>确 定</el-button
				>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="originalVisible" width="540px">
			<img style="width: 500px;height: 500px;" :src="originalImg" alt />
		</el-dialog>

		<international-channel
			ref="InternationalChannel"
			@close2="dialogClose"
		/>
	</div>
</template>

<script>
import UploadExcelComponent from '@/components/UploadExcel/index.vue'
import channelDepartment from './channelDepartment/channelDepartment'
import InternationalChannel from './channelDepartment/InternationalChannel'
import { ajaxPost, Baseurl } from '@/api/api/api'
import {getWaybillUrl, increaseNum} from '@/utils/common.js'
import JSZip from "jszip";
import { saveAs } from "file-saver";
import axios from 'axios'
export default {
	name: 'Channel',
	components: {
		channelDepartment,
		InternationalChannel,
		UploadExcelComponent
	},
	data() {
		return {
			exportWaybillContent: '',
			pageRadio: 'add',
			headClass: this.common.headClass,
			listBranch: [],
			listSon: [],
			RemarkList: [],
			formScreen: {
				branchCompanyId: '', //分公司
				companyId: '', //子公司
				startTimeString: '',
				endTimeString: '',
				searchString: '',
				searchStrings: '',
				isHasChannel: '',
				conveyNumber: '', //国际单号
				batchNo: '', //批次号
				orderMark:'',
				resource3: '',
				countryName: '',
				orderStatus: '',
				source: null,
				addressStatus: '',
			},
			checkList: [
				{
					value: '0',
					label: '未添加',
				},
				{
					value: '1',
					label: '已添加',
				},
			],
			listTable: [],
			UserInfo: {},
			page: 1,
			size: 20,
			total: 0,
			listWaybill: [],
			channelMark: '',
			dialogUpdateChannel: false,
			channelVal: '',
			loadingStatus: false,
			loadingTable: false,
			originalImg: '',
			originalVisible: false,
			checkedOrders: [],
			listCountry: [],
			Ymxpurchase: [
				{
					value: '1',
					label: '已取消',
				},
				{
					value: '2',
					label: '等待中',
				},
				{
					value: '3',
					label: '未发货',
				},
				{
					value: '4',
					label: '已发货',
				},
				{
					value: '5',
					label: '已退款',
				},
			],
			listTable1: [],
			loadingTable1: false,
			total1: 0,
			internationalOrderStatus: Object.freeze({
				0: { title: '未发货', color: 'blue' },
				1: { title: '作废', color: 'red' },
				2: { title: '未发货', color: 'blue' },
				3: { title: '未发货', color: 'blue' },
				4: { title: '已发货', color: 'green' },
				5: { title: '已签收', color: '#cc163a' },
				6: { title: '在途', color: '#feba07' },
				7: { title: '揽收', color: '#f97d1c' },
				8: { title: '疑难', color: '#ffa60f' },
				9: { title: '退签', color: '#de1c31' },
				10: { title: '派件', color: '#b7511d' },
				11: { title: '退回', color: '#ec4e8a' },
				12: { title: '转投', color: '#f09c5a' },
				13: { title: '待清关', color: '#619ac3' },
				14: { title: '清关中', color: '#2775b6' },
				15: { title: '已清关', color: '#22a2c3' },
				16: { title: '清关异常', color: '#ef498b' },
				17: { title: '拒签', color: '#c21f30' },
				18: { title: '清关', color: '#c21f30' },
				101: { title: '已下单', color: '#c21f30' },
				102: { title: '待揽收', color: '#c21f30' },
				103: { title: '已揽收', color: '#c21f30' },
				1001: { title: '到达派件城市', color: '#c21f30' },
				1002: { title: '干线', color: '#c21f30' },
				1003: { title: '转递', color: '#c21f30' },
				501: { title: '投柜或驿站', color: '#c21f30' },
				301: { title: '本人签收', color: '#c21f30' },
				302: { title: '派件异常后签收', color: '#c21f30' },
				303: { title: '代签', color: '#c21f30' },
				304: { title: '投柜或站签收', color: '#c21f30' },
				401: { title: '已销单', color: '#c21f30' },
				201: { title: '超时未签收', color: '#c21f30' },
				202: { title: '超时未更新', color: '#c21f30' },
				203: { title: '拒收', color: '#c21f30' },
				204: { title: '派件异常', color: '#c21f30' },
				205: { title: '柜或驿站超时未取', color: '#c21f30' },
				206: { title: '无法联系', color: '#c21f30' },
				207: { title: '超区', color: '#c21f30' },
				208: { title: '滞留', color: '#c21f30' },
				209: { title: '破损', color: '#c21f30' },
				210: { title: '销单', color: '#c21f30' },
			}),
			listChannel: [],
			colorlist:[],
			colorList4: {},
			channelUrl: {
				1: 'sanTaiController/updateShiptypes',
				2: 'yunTuController/getShippingMethods',
				3: 'yanWenController/getYanWenChannelTypeList',
				5: 'k5Controller/searchStartChannel',
				6: 'dsfController/getProductList',
				7: 'yunTuController/getShippingMethods',
				8: 'taiJiaController/getChannel',
				9: 'baDaTongController/getChannel',
				10: 'yunTuController/getShippingMethods',
				12: 'jieAnController/updateJieAnTypes',
				13: 'leaderTypeController/updateLeaderTypes',
				14: 'imlShippingMethodController/updateImlShippingMethod',
				17: 'baidianTypeController/updateBaidianTypes',
				18: 'baidianOwnTypeController/updateBaidianOwnTypes',
				19: 'wanLeaderTypeController/updateWanLeaderTypes',
				20: 'hydTypeController/updateHydTypes',
				21: 'cheerTypeController/updateCheerTypes',
				23: 'udaTypeController/updateUdaTypes',
				24: 'hydTypeController/updateHydTypes',
				25: 'aiparcelTypeController/updateAiparcelTypes',
				26: 'aiparcelTypeController/updateAiparcelTypes',
				29: 'aiparcelCodController/updateAiparcelCodTypes',
				30: 'ouyoutongController/updateOuyoutongTypes',
			},
			showFilter: true,
			exportDetail: false,
			textareaContent: '', // 用于存储textarea的内容
			amazonOrderIds: [],    // 用于存储分隔后的内容数组
			dialogVisible: false,
			importDetail: false,
			returnList: [],
			listFile: [],
			btnLoading: false,
			orderChannelInfoList: [],
			listFile2: [],
			platforms:[],
			exportWaybilldialog: false,
		}
	},
	created() {
		let API = Baseurl + 'purchaseController/selectItemList'
		ajaxPost(API, {itemCode:"HYXUN0000010"}).then((res) => {
			this.colorlist=res.data.data;
		})
		ajaxPost(API, {itemCode:"HYXUN0000007"}).then((res) => {
			this.listChannel=res.data.data;
		})
		ajaxPost(API, {itemCode:"HYXUN0000014"}).then((res) => {
			this.platforms=res.data.data;
		})
		this.UserInfo = JSON.parse(localStorage.getItem('role'))
		this.getThisMonth()
		this.handleGetTable()
		this.getBranchCompanyList()
		this.internationalTag()
		this.getListCountry()
		this.ordertypeTag()
	},
	computed: {
		listWaybillStatus() {
			return this.listWaybill.filter(
				(item) =>
					item.itemTypeId == 13 ||
					item.itemTypeId == 14 ||
					item.itemTypeId == 15 ||
					item.itemTypeId == 16 ||
					item.itemTypeId == 17 ||
					item.itemTypeId == 18 ||
					item.itemTypeId == 19
			)
		},
	},
	methods: {
		delay(ms) {
			return new Promise(resolve => setTimeout(resolve, ms));
		},
		exportWaybill(){
			console.log(123)
			console.log(this.exportWaybillContent);
			let str = this.exportWaybillContent;
			if(!str){
				this.$message.error('请输入订单号')
				return;
			}
			str = str.replace(/\n/g, ',');
			const params = {
				orderListStr: str
			}
			ajaxPost(Baseurl + 'logisticsController/getChannelList', params).then((res) => {
				console.log(res)
				if (res.data.code == 200) {
					const allPro = [];
					for(let i=0;i<res.data.data.length;i++){
						const item = res.data.data[i];
						item['channelId'] = item.id;
						allPro.push(this.openPrintPage(item));
					}
					console.log(allPro)
					Promise.all(allPro).then((values) => {
						console.log(values);
						const result = [];
						for(let i=0;i<values.length;i++){
							if(values[i]){
								result.push({
									url: values[i],
									name: res.data.data[i]['amazonOrderId']
								});
							}
						}
						this.downloadPdfZip(result);
					}) 

				} else {
					this.$message.error(res.data.message)
				}
			})	
		},
		async openPrintPage(item) {
			let url = ''; // 定义全局 URL
			let API = ''; // 如果需要调用接口
			let postData = {}; // 请求参数

			try {
				switch(item.type) {
					case 12:
						url = 'http://159.75.210.47:8089/order/FastRpt/PDF_NEW.aspx?PrintType=lab10_10&order_id=' + item.channelId;
						break;
					case 13:
						url = 'http://129.204.214.77:8089/order/FastRpt/PDF_NEW.aspx?PrintType=lab10_10&order_id=' + item.channelId;
						break;
					case 15:
					case 16:
						if (item.conveyNumberUrl) {
							url = item.conveyNumberUrl;
						} else {
							this.$message.error('暂无面单！');
							return;
						}
						break;
					case 17:
						url = 'http://47.96.42.132:8089/order/FastRpt/PDF_NEW.aspx?PrintType=lab10_10&order_id=' + item.channelId;
						break;
					case 18:
						API = Baseurl + 'baidian_order/getOrderLable';
						postData = { conveyNumber: item.conveyNumber };
						url = await getBlobUrl(API, postData);
						break;
					case 19:
						API = Baseurl + 'wanLeaderTypeController/getWanLeaderLabal';
						postData = { conveyNumber: item.conveyNumber };
						url = await getJsonBlobUrl(API, postData);
						break;
					case 20:
					case 24:
						url = 'http://1.14.254.116:8089/order/FastRpt/PDF_NEW.aspx?PrintType=lab10_10&order_id=' + item.channelId;
						break;
					case 21:
						url = 'http://106.52.235.113:8089/order/FastRpt/PDF_NEW.aspx?PrintType=lab10_10&order_id=' + item.channelId;
						break;
					case 22:
						API = Baseurl + 'jiTuTypeController/getPrintUrl';
						postData = { conveyNumber: item.conveyNumber };
						url = await getJsonBlobUrl(API, postData);
						break;
					case 23:
						API = Baseurl + 'udaTypeController/getUdaLabal';
						postData = { conveyNumber: item.conveyNumber };
						url = await getJsonBlobUrl(API, postData);
						break;
					case 25:
					case 26:
						url = item.conveyNumberUrl || 'http://159.75.205.97:8089/order/FastRpt/PDF_NEW.aspx?PrintType=lab10_10&order_id=' + item.channelId;
						break;
					case 27:
						if (item.conveyNumberUrl) {
							url = item.conveyNumberUrl;
						} else {
							API = Baseurl + 'dealfyController/getWaybill';
							postData = { conveyNumber: item.conveyNumber };
							url = await getJsonBlobUrl(API, postData);
						}
						break;
					case 28:
						if (item.conveyNumberUrl) {
							url = item.conveyNumberUrl;
						} else {
							API = Baseurl + 'cainiaoOrderController/getWaybill';
							postData = { conveyNumber: item.conveyNumber, type: 28 };
							url = await getJsonBlobUrl(API, postData);
						}
						break;
					case 29:
						if (item.conveyNumberUrl) {
							url = item.conveyNumberUrl;
						}
						break;
					case 30:
						url = 'http://43.139.202.31:8089/order/FastRpt/PDF_NEW.aspx?PrintType=lab10_10&order_id=' + item.channelId;
						break;
					case 31:
						if (item.conveyNumberUrl) {
							url = item.conveyNumberUrl;
						} else {
							API = Baseurl + 'cainiaoOrderController/getWaybill';
							postData = { conveyNumber: item.conveyNumber, type: 31 };
							url = await getJsonBlobUrl(API, postData);
						}
						break;
					case 32:
						if (item.channelWayEn === 'AE_GLOBAL_JIT') {
							API = Baseurl + 'aliexpressSemiHostingCollection/getShippingMarkPdf';
							postData = { sellerId: this.infoData.sellerId, purchaseOrderNo: item.fulfillmentId };
						} else {
							API = Baseurl + 'aliexpressLogistics/getPrintinfo';
							postData = { international_logistics_id: item.conveyNumber, sellerId: this.infoData.sellerId };
						}
						url = await getJsonBlobUrl(API, postData);
						break;
					case 33:
						API = Baseurl + 'walmartShipping/downloadLabel';
						postData = { sellerId: this.infoData.sellerId, trackingNo: item.conveyNumber, carrierShortName: item.channelName };
						url = await getJsonBlobUrl(API, postData);
						break;
					case 34:
						API = Baseurl + 'shangYiTypeController/getOrderLabel';
						postData = { conveyNumber: item.conveyNumber };
						url = await getJsonBlobUrl(API, postData);
						break;
					default:
						url = await getWaybillUrl(item);
						return url;
				}
				return url
				// await increaseNum(item);
			} catch (error) {
				console.error('', error);
				return null;
			}
		},

		// 辅助方法，用于返回 blob 流的 URL
		async getBlobUrl(api, data) {
			const res = await ajaxPost(api, data, { responseType: 'blob' });
			return res.data;
		},

		// 辅助方法，用于返回 JSON 内的 URL
		async getJsonBlobUrl(api, data) {
			const res = await ajaxPost(api, data, { responseType: 'blob' });
			const json = JSON.parse(res.data);
			return json.data;
		},

		async downloadPdfZip(pdfUrls) {
			const zip = new JSZip();

			// 遍历 PDF 链接
			for (let i = 0; i < pdfUrls.length; i++) {
				const url = pdfUrls[i]['url'];
				const name = pdfUrls[i]['name'] || `file_${i + 1}`
				try {
					const response = await axios.get(url, { responseType: "blob" });
					// 给每个文件命名
					const fileName = `${name}.pdf`;
					zip.file(fileName, response.data);
				} catch (err) {
					console.error(`下载失败: ${url}`, err);
				}
			}

			// 生成 zip
			const content = await zip.generateAsync({ type: "blob" });
			saveAs(content, "面单.zip"); // 下载压缩包
		},

		handleUploadExcelSubmit() {
			this.btnLoading = true
			ajaxPost(Baseurl + 'addressController/batchUpdateAddress', this.returnList).then((res) => {
				this.btnLoading = false
				if (res.data.code == 200) {
					this.$message.success("成功导入" + res.data.data + "条数据")
					this.dialogVisible = false
					this.listFile = []
					this.returnList = []
					this.searchFrom()
				} else {
					this.$message.error(res.data.message)
				}
			})
		},
		handleUploadExcelSubmit2() {
			this.btnLoading = true
			ajaxPost(Baseurl + 'logisticsController/importOrderChannel/' + this.UserInfo.rid, this.orderChannelInfoList).then((res) => {
				this.btnLoading = false
				if (res.data.code == 200) {
					this.$message.success("成功导入" + res.data.data.successCount + "条数据")
					if (res.data.data.errorList.length) {
						this.errorList = res.data.data.errorList
					} else {
						this.dialogVisible = false
						this.listFile2 = []
						this.orderChannelInfoList = []
					}
					
					this.searchFrom()
				} else {
					this.$message.error(res.data.message)
				}
			})
		},
		handleUploadExcelDialogClose() {
			this.dialogVisible = false
			this.listFile = []
			this.returnList = []
			this.listFile2 = []
			this.orderChannelInfoList = []
		},
		handleUploadExcelSuccess({ results, header, fileName }) {
			let returnList = results.map(item => ({
				id: item.id,
				name: item.收件人名称,
				addressLine1: item.地址1,
				addressLine2: item.地址2,
				addressLine3: item.地址3,
				city: item.城市,
				county: item.县,
				district: item.区,
				stateOrRegion: item.州或地区,
				municipality: item.自治市,
				postalCode: item.邮政编码,
				phone: item.电话,
			}))
			this.returnList.push(...returnList)
			this.listFile.push({ fileName })
		},
		handleUploadExcelSuccess2({ results, header, fileName }) {
			let orderChannelInfoList = results.map(item => ({
				conveyNumber: item.运单号,
				orderChannelId: item.渠道id,
				returnBarcode: item.退件单号,
				orderId: item.订单号,
				conveyNumberUrl: item.打标地址,
				channelWay: item.渠道方式,
				channelWayEn: item.渠道方式英文,
				destinationCountryMark: item.国家,
				sku: item.sku,
			}))
			this.orderChannelInfoList.push(...orderChannelInfoList)
			this.listFile2.push({ fileName })
		},
		downloadTemplate() {
			const a = document.createElement('a')
			a.href = 'https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/%E4%B9%B0%E5%AE%B6%E5%9C%B0%E5%9D%80%E6%A8%A1%E6%9D%BF%E4%BF%A1%E6%81%AF.xlsx'
			a.download = 'https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/%E4%B9%B0%E5%AE%B6%E5%9C%B0%E5%9D%80%E6%A8%A1%E6%9D%BF%E4%BF%A1%E6%81%AF.xlsx'
			a.click()
			this.$message.success('正在下载...')
		},
		downloadTemplate2() {
			const a = document.createElement('a')
			a.href = 'https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/%E7%AC%AC%E4%B8%89%E6%96%B9%E8%BF%90%E5%8D%95%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
			a.download = 'https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/%E7%AC%AC%E4%B8%89%E6%96%B9%E8%BF%90%E5%8D%95%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
			a.click()
			this.$message.success('正在下载...')
		},
		updateContentArray() {
			// 使用换行符分隔内容并更新amazonOrderIds数组
			const lines = this.textareaContent.split('\n');
			// 过滤掉空行
			this.amazonOrderIds = lines.filter(line => line.trim() !== '');
		},
		submitRemark() {
			console.log(this.amazonOrderIds);
			if (this.amazonOrderIds.length < 1) {
				this.$message.error("请填写订单号")
				return
			}
			let contentArrays = this.amazonOrderIds.join(",")
			console.log(contentArrays);
			window.open(`${Baseurl}/addressController/exportAddressDetails?amazonOrderIds=${contentArrays}`, 'target');
			setTimeout(() => {
				this.exportDetail = false
				this.$nextTick(() => {
					this.textareaContent = ''
					this.amazonOrderIds = ['']
					this.exportDetail = false
				})
			}, 500)
		},
		closeRemark() {
			this.textareaContent = ''
			this.amazonOrderIds = ['']
			this.exportDetail = false
		},
		clearFilter() {
			this.$refs.filterTable.clearFilter();
		},
		filterTag(value, row) {
			if(row.channelTask && Object.keys(row.channelTask).length) {
				return row.channelTask.status === value;
			}
			if(!row.channelTask){
				return value == '--'
			}
		},
		// 获取默认时间(一个月)
		getThisMonth() {
			const nowDate = new Date()
			const nowTimeStamp = nowDate.getTime()
			const nowYear = nowDate.getFullYear()
			const nowMonth = nowDate.getMonth() + 1
			const nowDay = nowDate.getDate()

			const startTimeStamp = nowTimeStamp - (3600 * 1000 * 24 * 30)
			const startDate = new Date(startTimeStamp)
			const startYear = startDate.getFullYear()
			const startMonth = startDate.getMonth() + 1
			const startDay = startDate.getDate()

			this.formScreen.startTimeString = `${startYear}-${startMonth}-${startDay} 00:00:00`
			this.formScreen.endTimeString = `${nowYear}-${nowMonth}-${nowDay} 23:59:59`
		},
		//订单类型标签
		ordertypeTag() {
			var obj = { itemCode: 'HYXUN0000015' }
			ajaxPost(Baseurl + 'purchaseController/selectItemList', obj).then(
				(res) => {
					if (res.data.code == 200) {
						let obj = {};
						res.data.data.forEach(item => {
							obj[item.itemTypeId] = item
						});
						this.colorList4 = obj;
					}
				}
			)
		},
		submitUpdateChannel() {
			let API = ''
			if (this.channelVal == 12) {
				API = Baseurl + 'jieAnController/updateJieAnTypes'
				this.loadingStatus = true
				ajaxPost(API).then((res) => {
					this.loadingStatus = false
					const { code } = res.data
					if (code === 200) {
						this.dialogUpdateChannel = false
						this.$message.success('操作成功')
					}
				})
			} else {
				API = Baseurl + this.channelUrl[this.channelVal]
				this.save(API)
			}
		},
		save(API) {
			const paramsData = {
				countryCode: '',
				companyId: this.UserInfo.company_id,
				type: this.channelVal,
				applyFromStatus: this.UserInfo.company.selfUseChannelSwitch + 1,
			}
			this.loadingStatus = true
			ajaxPost(API, paramsData).then((res) => {
				this.loadingStatus = false
				const { code } = res.data
				if (code === 200) {
					this.dialogUpdateChannel = false
					this.$message.success('操作成功')
				}
			})
		},
		edit(row) {
			this.$refs.channelDepartment.init(row, this.pageRadio)
		},
		searchFrom() {
			this.page = 1
			this.handleGetTable()
		},
		resetFprm(formName) {
			this.page = 1
			this.$refs[formName].resetFields()
			this.listSon = []
			this.channelMark = ''
			this.formScreen.resource3 = ''
			this.formScreen.orderMark='';
			this.formScreen.orderType='';
			this.formScreen.startTimeString = ''
			this.formScreen.endTimeString = ''
			this.formScreen.source = null
			this.handleGetTable()
		},
		handleSizeChange(val) {
			this.size = val
			this.handleGetTable()
		},
		handleCurrentChange(val) {
			this.page = val
			this.handleGetTable()
		},
		handleRadioChange() {
			if (this.pageRadio === 'recordSKU') {
				this.$router.push({ name: 'recordSKU' })
				this.pageRadio = 'add'
				return
			} else if (this.pageRadio === 'updateChannel') {
				this.dialogUpdateChannel = true
				this.pageRadio = 'add'
				return
			} else if (this.pageRadio === 'channelConfigure') {
				this.$router.push({ name: 'channelConfigure' })
				this.pageRadio = 'add'
				return
			}
			this.page = 1
			this.handleGetTable()
		},
		getListCountry() {
			const API =
				Baseurl +
				'logisticsConfigurationController/selectLogisticsCountryList'
			ajaxPost(API).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.listCountry = data
				}
			})
		},
		handleGetTable() {
			if (this.pageRadio === 'add') {
				this.getListTable()
			} else if (this.pageRadio === 'revise') {
				this.getListTable1()
			}
		},
		getListTable() {
			let API = Baseurl + 'logisticsController/getChannelOrderList'
			const paramsData = {
				channelMark: this.channelMark,
				page: this.page,
				size: this.size,
				roleId: this.UserInfo.rid,
				companyId: this.UserInfo.company_id,
				...this.formScreen,
				orderMark:this.formScreen.orderMark,
				source: this.formScreen.source ? parseInt(this.formScreen.source) : null
			}
			if (this.formScreen.searchStrings) {
				this.$set(paramsData, 'searchStrList', this.formScreen.searchStrings.split(' '))
			} else {
				this.$set(paramsData, 'searchStrList', [])
			}
			this.loadingTable = true
			ajaxPost(API, paramsData).then((res) => {
				const { code, data } = res.data
				this.loadingTable = false
				if (code === 200) {
					this.listTable = data.list
					this.total = data.total
					for(var i=0;i<this.listTable.length;i++){
						// <div :style="{background:scope.row.sellercolor">{{scope.row.itemTypeName}}</div>
						for(var a=0;a<this.colorlist.length;a++){
							if(this.listTable[i].orderMark===this.colorlist[a].itemTypeId){
								this.listTable[i].sellercolor=this.colorlist[a].itemName;
								this.listTable[i].itemTypeName=this.colorlist[a].itemTypeName;
							}
						}
					}
					for(var i=0;i<this.listTable.length;i++){
						for(var a=0;a<this.platforms.length;a++){
							if(this.listTable[i].source==this.platforms[a].itemTypeId){
								this.listTable[i].sourceclass=this.platforms[a].itemTypeName;
							}
						}
					}
				}
			})
		},
		getListTable1() {
			const API = Baseurl + 'logisticsController/getChannelDemandList'
			const paramsData = {
				channelMark: this.channelMark,
				page: this.page,
				size: this.size,
				roleId: this.UserInfo.rid,
				companyId: this.UserInfo.company_id,
				...this.formScreen,
			}
			if (this.formScreen.searchStrings) {
				this.$set(paramsData, 'searchStrList', this.formScreen.searchStrings.split(' '))
			} else {
				this.$set(paramsData, 'searchStrList', [])
			}
			this.loadingTable1 = true
			ajaxPost(API, paramsData).then((res) => {
				const { code, data } = res.data
				this.loadingTable1 = false
				if (code === 200) {
					this.listTable1 = data.list
					this.total1 = data.total
				}
			})
		},
		channelChangeConfirm(id) {
			const API = Baseurl + 'logisticsController/updateChannelResultById'
			const paramsData = {
				roleId: this.UserInfo.rid,
				channelResult: 1,
				id,
			}
			ajaxPost(API, paramsData).then((res) => {
				const { code } = res.data
				if (code === 200) {
					this.$message.success('操作成功')
					this.getTableData()
				} else {
					this.$message.error('操作失败')
				}
			})
		},
		selectChange(id) {
			this.formScreen.companyId = ''
			this.getSonCompanyList(id)
		},
		getBranchCompanyList() {
			const API = Baseurl + 'logisticsController/getAllBranchCompany'
			ajaxPost(API).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.listBranch = data
				}
			})
		},
		getSonCompanyList(id) {
			const API = Baseurl + 'logisticsController/getAllSubCompanyById'
			const paramsData = { id }
			ajaxPost(API, paramsData).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.listSon = data
				}
			})
		},
		channelDepartmentConfirm() {
			this.handleGetTable()
		},
		handleClose() {
			this.handleGetTable()
		},
		radiochange3(val) {
			this.channelMark = val
			this.handleGetTable()
		},
		radiochange4() {
			
			this.handleGetTable()
		},
		radiochange5() {
			
			this.handleGetTable()
		},
		//国际运单标记
		internationalTag() {
			var obj = { itemCode: 'HYXUN0000012' }
			ajaxPost(Baseurl + 'purchaseController/selectItemList', obj).then(
				(res) => {
					if (res.data.code == 200) {
						this.listWaybill = res.data.data
					}
				}
			)
		},
		getOriginalImg(item) {
			// console.log(item)
			const API = Baseurl + 'productController/selectImagesByChildSku'
			const paramsData = {
				childSku: item.sellerSKU,
			}
			ajaxPost(API, paramsData).then((res) => {
				const { code, data, message } = res.data
				if (code === 200) {
					this.originalImg = data
					this.originalVisible = true
				} else {
					this.$message.error(message)
				}
			})
		},
		batchCreateWaybill() {
			if (!this.checkedOrders.length) {
				this.$message.warning('请至少选择一个订单！')
				return
			}
			const temporaryData = {
				roleId: this.UserInfo.rid,
				checkedOrders: this.checkedOrders,
			}
			this.$refs.InternationalChannel.initComponents2(temporaryData)
		},
		handleSelectionChange(event) {
			// console.log(event)
			this.checkedOrders = event
		},
		dialogClose() {
			// this.page = 1
			console.log(1)
			this.handleGetTable()
		},
		orderIdchange(val) {
			const API =
				Baseurl + 'logisticsRemarkController/selectLogisticsRemarkList'
			const paramsData = {
				orderId: val.orderId,
			}
			ajaxPost(API, paramsData).then((res) => {
				if (res.data.code === 200) {
					this.RemarkList = res.data.data
				} else {
					this.$message.error(res.data.data)
				}
			})
		},
		/**
		 * radio取消选中
		 */
		cancelSelect(e, label) {
			e === this.formScreen[label] ? this.formScreen[label] = '' : this.formScreen[label] = e
			if (label == 'orderMark') {
				this.radiochange4(this.formScreen[label])
			}
			if (label == 'resource3') {
				this.radiochange3(this.formScreen[label])
			}
			if (label == 'orderType') {
				this.radiochange5(this.formScreen[label])
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.channel {
	width: 98%;
	overflow: hidden;
	padding-bottom: 52px;

	/deep/ .el-divider--horizontal {
		margin: 2px 0;
	}

	.custom-formScreen {
		::v-deep {
			.el-form-item {
				width: 20%;
				margin-right: 0;
			}

			.el-form-item__content {
				width: calc(100% - 5vw);

				.el-select,
				.el-date-editor,
				.el-input {
					width: 100%;
				}
			}
		}
	}

	.pagination-box {
		width: calc(97% - 200px);
		background: #fff;
		position: fixed;
		bottom: 0;
		left: 200px;
		padding: 10px;
		z-index: 999;
	}
}

.scope_img {
	width: 55px;
	height: 55px;

	img {
		width: 100%;
		height: 100%;
	}
}

.prduct_img {
	width: 500px;
	height: 500px;
}

.el-tag--dark {
	border: 0;
}

.Memo {
	width: 25px;
	height: 25px;
}
</style>
